var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"pmap",staticClass:"google-map"})])
}
var staticRenderFns = []

export { render, staticRenderFns }